import classNames from 'classnames'
import React, {useEffect, useRef, useState} from 'react'
import {getImageStyle} from '../../../../../../commons/utils/image'
import s from './group-image.scss'
import {GroupImageProps} from '.'

export const GroupImage = ({image, className}: GroupImageProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [container, setContainer] = useState(null)

  useEffect(() => {
    setContainer(ref.current?.getBoundingClientRect())
  }, [])

  return (
    <div className={classNames(className, s.root)} ref={ref}>
      {container ? <Image container={container} image={image} /> : null}
    </div>
  )
}

const Image = ({container, image}) => {
  const {src, styles} = getImageStyle({
    image,
    container,
  })
  return <img className={s.img} src={src} style={styles} alt=" " />
}
